import React, { useEffect, useRef, useState } from "react";
import { listarEmpresasNomes } from "../services/api";

export default function SearchBar({ placeholder = "Pesquise...", onSearch }) {
  const [valor, setValor] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [ativo, setAtivo] = useState(-1); // índice destacado p/ navegação por teclado (a11y)
  const ref = useRef(null);

  useEffect(() => { listarEmpresasNomes().then(setEmpresas).catch(() => {}); }, []);
  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const disparar = (v) => { onSearch?.((v ?? valor).trim()); setAberto(false); setAtivo(-1); };
  const onKey = (e) => {
    if (aberto && sugestoes.length > 0) {
      if (e.key === "ArrowDown") { e.preventDefault(); setAtivo((i) => Math.min(i + 1, sugestoes.length - 1)); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); setAtivo((i) => Math.max(i - 1, 0)); return; }
      if (e.key === "Escape") { setAberto(false); setAtivo(-1); return; }
      if (e.key === "Enter" && ativo >= 0) { e.preventDefault(); const s = sugestoes[ativo]; setValor(s.nome); disparar(s.nome); return; }
    }
    if (e.key === "Enter") disparar();
  };

  const q = valor.trim().toLowerCase();
  // Abre já listando (mais citadas primeiro) e filtra conforme digita — estilo Reclame Aqui.
  const filtradas = q.length >= 1
    ? empresas.filter((e) => e.nome.toLowerCase().includes(q))
    : [...empresas].sort((a, b) => (b.totalDenuncias || 0) - (a.totalDenuncias || 0));
  const sugestoes = filtradas.slice(0, 8);

  return (
    <div className="relative" ref={ref}>
      <input
        type="text"
        value={valor}
        onChange={(e) => { setValor(e.target.value); setAberto(true); setAtivo(-1); }}
        onFocus={() => setAberto(true)}
        onKeyDown={onKey}
        placeholder={placeholder}
        autoComplete="off"
        role="combobox"
        aria-expanded={aberto && sugestoes.length > 0}
        aria-controls="busca-sugestoes"
        aria-activedescendant={ativo >= 0 ? `busca-opt-${ativo}` : undefined}
        aria-label={placeholder}
        className="w-full rounded-2xl border border-gray-200 bg-white px-5 py-3 pr-12 shadow-sm outline-none focus:ring-2 focus:ring-primary"
      />
      <button
        aria-label="Pesquisar"
        onClick={() => disparar()}
        className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gray-100 hover:bg-gray-200"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-5.2-5.2M10.5 18a7.5 7.5 0 110-15 7.5 7.5 0 010 15z" />
        </svg>
      </button>
      {aberto && sugestoes.length > 0 && (
        <ul id="busca-sugestoes" role="listbox" className="absolute z-30 mt-1 w-full rounded-xl border border-gray-200 bg-white shadow-lg max-h-60 overflow-auto">
          {sugestoes.map((e, idx) => (
            <li
              key={e.id}
              id={`busca-opt-${idx}`}
              role="option"
              aria-selected={idx === ativo}
              onMouseEnter={() => setAtivo(idx)}
              onClick={() => { setValor(e.nome); disparar(e.nome); }}
              className={`cursor-pointer px-4 py-2.5 text-sm flex items-center justify-between gap-2 ${idx === ativo ? "bg-gray-100" : "hover:bg-gray-100"}`}
            >
              <span className="text-gray-800">{e.nome}</span>
              <span className="text-xs text-gray-400 shrink-0">{(e.totalDenuncias || 0) + (e.totalElogios || 0)} relato(s)</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
